import { render, staticRenderFns } from "./ClientEditComponent.vue?vue&type=template&id=2939a8ec&"
import script from "./ClientEditComponent.vue?vue&type=script&lang=js&"
export * from "./ClientEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports